import analytics from "../../analytics";
import { CSSEvent } from "../../types/model";

export function sendPageView(event: CSSEvent) {
  analytics.sendPageview({
    page_type: "events",
    local_store: event.location.store.storeNo,
  });
}

export function sendSignUpEvent(event: CSSEvent) {
  const storeNo = event.location.store.storeNo;
  analytics.sendEvent(
    {
      label: storeNo,
      action: "event_signup_begun",
    },
    {
      page_type: "events",
      local_store: storeNo,
    }
  );
}
